<template>  
    <div ref="rootEl" class="select" :class="{'isError': props.isError}" @click="showOptions = !showOptions" style="cursor:pointer">

        <span v-if="selectedItem">
            {{ props.showProp ? selectedItem[props.showProp] : selectedItem }}
            <!-- <i v-if="!props.disabled" class="material-icons float-left" @click.stop="selectedItem = null; select()">close</i> -->
             <i class="material-icons float-left">expand_more</i>
        </span>

        <i v-else class="material-icons float-left">expand_more</i>

        <label :class="{'stay-top': !!selectedItem}">{{props.label}}</label>


        <ul v-if="showOptions">
            <li v-for="(option, idx) in props.options" :key="idx" @click.stop="selectedItem = option; select()">{{ props.showProp ? option[props.showProp] : option }}</li>                    
        </ul>
    </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, onMounted, onBeforeUnmount } from 'vue'

const rootEl = ref(null) // ref al div.select

function handleClickOutside(event) {
  if (rootEl.value && !rootEl.value.contains(event.target)) {
    showOptions.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside, true)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside, true)
})

const emit = defineEmits(['select'])
const props = defineProps({
    label: String,
    options: Array,
    showProp: String,
    loadValue: [String, Number],
    loadProp: String,
    disabled: Boolean,
    isError: Boolean
})

const showOptions = ref(false);
const selectedItem = ref(null);

function select(){
    emit('select', selectedItem.value);
    showOptions.value = false;
}

if(props.loadProp && props.loadValue){
    selectedItem.value = props.options.find(el => el[props.loadProp] == props.loadValue)
} else if(!props.loadProp && props.loadValue){
    selectedItem.value = props.options.find(el => el == props.loadValue)
}

</script>

<style lang="scss" scoped>
$input-bg: #F6F6F6;

.select{
    position: relative;
    width: 100%;
    height: 50px;
    background: $input-bg;
    padding: 12px 28px 12px 28px;
    border-radius: 50px;
    //background: red;
    span{
        padding-top: 8px;
        width: 100%;
        display: flex;
        //justify-content: space-between;
        //align-items: center;
        font-size: 13px;
        font-weight: 400;
        .material-icons{
            top: 14px;
            cursor: pointer;
            font-size: 20px;
        }
    }
    label{
        //cursor: text;
        top: 0;
        //left: 28px;
        //-webkit-user-select: none;
        //-moz-user-select: none;
        //-ms-user-select: none;
        //user-select: none;
        transform: translateY(12px);
        transition: transform .5s, color .3s, font-size .5s;
        //line-height: 25px;
        font-size: 13px;
        font-weight: 400;
        //pointer-events: none;
        &.stay-top{
            position: absolute;
            transform: translateY(6px);
            font-size: 10px;
            //font-weight: 600;
            color: $orange;
        }
    }
    .float-left{
        position: absolute;
        right: 20px;
    }
    ul{
        margin-bottom: 26px;
        width: 100%;
        max-height: 200px;
        overflow-y: auto;
        position: absolute;
        top: 54px;
        left: 0;
        padding: 12px 0;
        display: flex;
        flex-direction: column;
        gap: 6px;
        background: $input-bg;
        box-shadow: 0px 4px 4px 0px #00000040;
        border-radius: 10px;
        z-index: 20;
        li{
            font-size: 13px;
            padding: 2px 12px;
            cursor: pointer;
            &:hover{
                background: #fff;
            }
        }
    }
    &.isError{
        border: 1px solid $red;
    }
}

</style>